import { createContext, useContext } from 'react'

import type { UseStateMachineEditorReturn } from '../hooks/useStateMachineEditor'

const StateMachineEditorContext = createContext<UseStateMachineEditorReturn | null>(null)

export const StateMachineEditorProvider = StateMachineEditorContext.Provider

export function useStateMachineEditorContext(): UseStateMachineEditorReturn {
  const context = useContext(StateMachineEditorContext)

  if (!context) {
    throw new Error('useStateMachineEditorContext must be used within a StateMachineEditorProvider')
  }

  return context
}
